/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Grid, TextField } from '@material-ui/core';
import { Button } from 'react-bootstrap';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import { RequestMonthlyClaimReconciliationTableHead } from './TableHead';
import {
  getRequestScreenGrid,
  getTableHeaderGrid,
  selectedRequest,
  getLastUpdatedUseridAndCount,
  getMonthlyClaimsReconciliationShedule,
  setScheduleMessage,
  setLastUpdatedUseridAndCount,
  setSearchInput,
  getDisplayScreenLeftGrid,
  getDisplayScreenRightGrid,
} from '../Store/actions';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import {
  autoFormateDate,
  getCurrentDate,
  removeErr,
  tabHighLigther,
} from '../../../../SharedModules/utilities/utilities';
import {
  validateDateQuarter,
  compareDate,
  quarterToDate,
  convertStringDate,
} from '../../../../SharedModules/utilities/dateUtilities';

import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import Fieldset from '../../../../SharedModules/Fieldset/Fieldset';

import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
import { TO_DATE_GREATER_THAN_FROM } from '../../../../SharedModules/Errors/constantMessageData';
import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';
import { handleScrollToEvent } from '../../../../SharedModules/CommonUtilities/commonUtilities';

const MonthlyClaimReconcilliationRequest = (props) => {
  const dispatch = useDispatch();
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);    
  const hasRole = (role) =>
          kcRoles?.userPrivileges?.some((r) => r === role) || false;
  const disableOtherButtons =
        hasRole('State Employee');
      

  const {
    errors,
    isLoading,
    selectedOption: selectedOptionValue,
    screenGridData,
    // qtr: qtrValue,
    fromDate: fromDateValue,
    toDate: toDateValue,
    leftGridData,
    rightGridData,
    lasUpdatedUserIdAndCount,
    scheduleMessage,
  } = useSelector(
    (state) => state?.sharedState?.MonthlyClaimsReconcilliationReducer
  );

  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );

  const [radioList, setRadioList] = React.useState([
    {
      value: 'Request Running Of Monthly Report',
      name: 'Request Running Of Monthly Report',
      id: 'Request Running Of Monthly Report',
    },
    {
      value: 'Request Display Of Monthly Report',
      name: 'Request Display Of Monthly Report',
      id: 'Request Display Of Monthly Report',
    },
  ]);
  const [selectedOption, setSelectedOption] =
    React.useState(selectedOptionValue);

  const [errorList, setErrorList] = React.useState(errors);
  const [isSearchClicked, setSearchClicked] = React.useState(false);
  const [isScheduleClicked, setScheduleClicked] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [fromDate, setFromDate] = React.useState(fromDateValue);
  const [toDate, setToDate] = React.useState(toDateValue);

  // function to validate from Date and toDate on onblur
  const handleOnBlur = (type, input) => {
    const value = autoFormateDate(input);
    let allErrors = errorList;
    let fromError = [];
    let toError = [];
    if (type === 'fromDate') {
      setFromDate(value.toUpperCase());
      fromError = validateDateQuarter(value, 'fromDate');
      allErrors = [...allErrors, ...fromError];
      if (fromError.length === 0 && !toDate) {
        setToDate(value.toUpperCase());
      }
    }
    if (type === 'toDate') {
      setToDate(value.toUpperCase());
      toError = validateDateQuarter(value, 'toDate');
      allErrors = [...allErrors, ...toError];
    }

    if (fromError.length === 0 && toError.length === 0) {
      if (compareDate(fromDate, toDate)) {
        allErrors.push({
          field: 'fromDate>toDate',
          message: TO_DATE_GREATER_THAN_FROM,
        });
      } else {
        allErrors = removeErr(allErrors, [TO_DATE_GREATER_THAN_FROM]);
      }
    }
    allErrors = [...allErrors];
    setErrorList(allErrors);
  };

  React.useEffect(() => {
    if (
      isSearchClicked &&
      (leftGridData?.length > 0 || rightGridData?.length)
    ) {
      setSearchClicked(false);
      const updateTabs =
        JSON.parse(localStorage.getItem('tabItemsData')) === null
          ? []
          : JSON.parse(localStorage.getItem('tabItemsData'));
      updateTabs.push({
        navTo: '/monthlyclaimsreconcilliationdetails',
        value: 'Display Monthly Claims Reconciliation',
      });
      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
      props.history.push({
        pathname: '/monthlyclaimsreconcilliationdetails',
      });
      dispatch(
        clearReduxForFilterAndSort('/monthlyclaimsreconcilliationdetails')
      );
    }
  }, [leftGridData, rightGridData]);

  React.useEffect(() => {
    setErrorList(errors);
  }, [errors]);
  const [rows, setRows] = React.useState([]);
  const [fullScreenView, setFullScreenView] = React.useState(false);

  const clearSchedule = () => {
    if (scheduleMessage !== null) {
      dispatch(setScheduleMessage(null));
    }
    if (lasUpdatedUserIdAndCount !== null) {
      dispatch(setLastUpdatedUseridAndCount(null));
    }
  };
  // Function to toggle fullscreen view of table
  const changeFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };

  // Set the table data rows
  React.useEffect(() => {
    setRows(screenGridData);
  }, [screenGridData]);

  React.useEffect(() => {
    handleScrollToEvent();
    dispatch(getRequestScreenGrid());
  }, []);

  // Highlights the tab if any error
  React.useEffect(() => {
    if (errorList.length > 0) {
      tabHighLigther('/monthlyclaimsreconcilliation', true);
    } else {
      tabHighLigther('/monthlyclaimsreconcilliation', false);
    }
  }, [JSON.stringify(errorList)]);

  const handleScheduleClick = () => {
    let allErrors = errorList;

    const fromError = validateDateQuarter(fromDate, 'fromDate');
    const toError = validateDateQuarter(toDate, 'toDate');
    if (fromError.length === 0 && toError.length === 0) {
      if (compareDate(fromDate, toDate)) {
        allErrors.push({
          field: 'fromDate>toDate',
          message: TO_DATE_GREATER_THAN_FROM,
        });
      }
    }
    allErrors = [...allErrors, ...fromError, ...toError];
    setErrorList(allErrors);
    dispatch(
      setSearchInput({
        errors: allErrors,
        selectedOption,
        fromDate,
        toDate,
      })
    );
    if (allErrors.length === 0) {
      setScheduleClicked(true);
      let fromDateValue = fromDate;
      let toDateValue = toDate;
      if (fromDateValue.includes('Q')) {
        fromDateValue = convertStringDate(
          quarterToDate(fromDateValue, 'fromDate')
        );
      }
      if (toDateValue?.includes('Q')) {
        toDateValue = convertStringDate(quarterToDate(toDateValue, 'toDate'));
      }
      dispatch(
        getLastUpdatedUseridAndCount({
          startDt: fromDateValue,
          endDt: toDateValue,
          userName: userDefaults?.userId,
        })
      );
    }
  };
  const handleAction = (input, value) => {
    let fromDateValue = fromDate;
    let toDateValue = toDate;
    if (fromDateValue.includes('Q')) {
      fromDateValue = convertStringDate(
        quarterToDate(fromDateValue, 'fromDate')
      );
    }
    if (toDateValue?.includes('Q')) {
      toDateValue = convertStringDate(quarterToDate(toDateValue, 'toDate'));
    }
    if (value === undefined || value === 'button') {
      dispatch(
        getMonthlyClaimsReconciliationShedule({
          userName: userDefaults?.userId,
          todaysDt: getCurrentDate('MM/DD/YYYY'),
          isOverWrite: input,
          startDt: fromDateValue,
          endDt: toDateValue,
        })
      );
    }
  };

  React.useEffect(() => {
    if (
      lasUpdatedUserIdAndCount !== 'NoRequestExist' &&
      lasUpdatedUserIdAndCount !== null &&
      lasUpdatedUserIdAndCount !== 'default'
    ) {
      setOpen(true);
    } else if (
      lasUpdatedUserIdAndCount === 'NoRequestExist' &&
      isScheduleClicked
    ) {
      handleAction('Yes');
    }
    setScheduleClicked(false);
  }, [lasUpdatedUserIdAndCount]);
  // Handle cell click
  const cellClickedListener = (e) => {
    dispatch(
      setSearchInput({
        errors: errorList,
        selectedOption,
        fromDate,
        toDate,
      })
    );
    dispatch(selectedRequest(e?.data));
    setSearchClicked(true);

    const { startDate, endDate, requestedDate, requestorUserId } =
      e?.data || {};
    dispatch(
      getDisplayScreenRightGrid({
        startDate: startDate,
        endDate: endDate,
      })
    );
    dispatch(
      getDisplayScreenLeftGrid({
        adStartDate: startDate,
        adEndDate: endDate,
        adRequestDate: requestedDate,
        requestorUserId: requestorUserId,
      })
    );
  };

  const errorMessages = [
    ...new Set(
      errorList.map((obj) =>
        obj.message
          .replace('From date', 'Begin date')
          .replace('To date', 'End date')
      )
    ),
  ];
  return (
    <div className="tabs-container">
      <Spinner load={isLoading} />

      <CustomSeparator
        parent1="State Reports"
        parent2="Monthly Claims Reconciliation Report"
      />

      <DisplayErrorMessages errorMessages={errorMessages.map((l) => l)} />
      {scheduleMessage && scheduleMessage.messageAfterInsertOfRecordsInDb && (
        <div className="alert alert-info custom-alert text-left" role="alert">
          {scheduleMessage.messageAfterInsertOfRecordsInDb}
        </div>
      )}

      <div className="tab-body">
        <CommonModal
          open={open}
          data-testid="comman_modal1"
          viewAction
          viewHeader
          className="dialogPanel frr-rightAlignment custom-check dialog-420"
          onOk={() => {
            setOpen(false);

            handleAction('Yes');
          }}
          okTitle="Yes"
          onClose={(value) => {
            handleAction('No', value);
            setOpen(false);
          }}
          closeTitle="No"
          modalTitle="Please Confirm"
          childrenComponent={
            <div>
              <p>{lasUpdatedUserIdAndCount?.overWriteMessage}</p>
            </div>
          }
        />
        {!fullScreenView && (
          <div className="row">
            <div className="col-6 frr-one-col-radio">
              <RadioGroupComponent
                data-testid="Monthly-claims-Reconcilition-plan-type"
                id="filter-plan-by-radio-btn-action"
                labelName="Request Options"
                required={false}
                optionList={radioList || []}
                defaultValue={selectedOption}
                filterAction={(value) => {
                  setSelectedOption(value);
                  clearSchedule();
                  setErrorList([]);
                }}
                className="log-batch-filter-radio frr-checkInvoiceRadio"
              />
            </div>
            {selectedOption === 'Request Running Of Monthly Report' && (
              <div className="col-4">
                <Fieldset label="Date Range">
                  <div className="form-wrapper p-0 mt-n3">
                    <div className="mui-custom-form input-md field-xl">
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                          <TextField
                            label="Begin Date"
                            id="Begin Date"
                            placeholder=""
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{
                              maxLength: 10,
                              'aria-describedby': '',
                            }}
                            required
                            name="From"
                            value={fromDate}
                            error={
                              errorList.filter(
                                (error) => error.field === 'fromDate'
                              )?.length > 0
                                ? 'mandate-fields'
                                : ''
                            }
                            data-testid="MonthlyClaim-Reconcilition-from-date"
                            helperText={errorList
                              .find((error) => error.field === 'fromDate')
                              ?.message.replace('From date', 'Begin date')
                              .replace('To date', 'End date')}
                            className="mandate-fields"
                            onBlur={(e) =>
                              handleOnBlur('fromDate', e.target.value)
                            }
                            onChange={(e) => {
                              clearSchedule();
                              setFromDate(e.target.value.toUpperCase());
                              setErrorList([
                                ...errorList.filter(
                                  (error) => error.field !== 'fromDate'
                                ),
                              ]);
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <TextField
                            label="End Date"
                            id="End Date"
                            data-testid="MonthlyClaim-Reconcilition-to-date"
                            placeholder=""
                            InputLabelProps={{
                              shrink: true,
                            }}
                            required
                            inputProps={{
                              maxLength: 10,
                              id: 'End Date',
                              'aria-describedby': '',
                            }}
                            name="to"
                            value={toDate}
                            onBlur={(e) =>
                              handleOnBlur('toDate', e.target.value)
                            }
                            onChange={(e) => {
                              clearSchedule();
                              setToDate(e.target.value.toUpperCase());
                              setErrorList([
                                ...errorList.filter(
                                  (error) =>
                                    error.field !== 'toDate' &&
                                    error.field !== 'fromDate>toDate'
                                ),
                              ]);
                            }}
                            error={
                              errorList.filter(
                                (error) =>
                                  error.field === 'toDate' ||
                                  error.field === 'fromDate>toDate'
                              )?.length > 0
                                ? 'mandate-fields'
                                : ''
                            }
                            helperText={errorList
                              .find(
                                (error) =>
                                  error.field === 'toDate' ||
                                  error.field === 'fromDate>toDate'
                              )
                              ?.message.replace('From date', 'Begin date')
                              .replace('To date', 'End date')}
                            className="mandate-fields"
                          />
                        </Grid>
                      </Grid>
                    </div>
                  </div>
                </Fieldset>
              </div>
            )}

            {selectedOption === 'Request Running Of Monthly Report' && (
              <div className="row" style={{ marginTop: 30 }}>
                <div className="btn-wrapper col-12">
                  <Button
                    data-testid="checkAllocation-searchbtnclick"
                    onClick={handleScheduleClick}
                    className="btn btn-success btn-search float-right"
                    disabled={disableOtherButtons}
                  >
                    Schedule
                  </Button>
                </div>
              </div>
            )}
          </div>
        )}

        {selectedOption !== 'Request Running Of Monthly Report' && (
          <div className="row" style={{ marginTop: 15 }}>
            <div className="unallocated" style={{ width: '100vw' }}>
              <TableGridWithFeatures
                gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
                columnDefs={RequestMonthlyClaimReconciliationTableHead}
                rowData={rows}
                data-testid="onEditingStopped"
                enterMovesDown
                showResetFilter={false}
                defaultCol={{
                  wrapHeaderText: true,
                  autoHeaderHeight: true,
                }}
                cellClickedListener={cellClickedListener}
                hideTotalCount={false}
                exportFile
                fileName="Monthly Claim Request Grid"
                fullScreenView={fullScreenView}
                handleFullScreenViewClick={changeFullScreenView}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MonthlyClaimReconcilliationRequest;
